/* eslint-disable react-hooks/rules-of-hooks */
import React, { useMemo } from 'react';
import { Link, Navigate, useParams } from 'react-router-dom';
import WbsListContainer from 'src/features/wbs/WbsListContainer';
// import { WbsListMode } from 'src/features/wbs/types';
import { useProjectAccessCtx } from 'src/features/projects/ProjectAccessContext';
import { hasPerm } from 'src/features/projects/hooks/useProjectAccess';
import { useWbsCurrent } from './repo';

export default function WbsPage() {
    const { projectId } = useParams<{ projectId: string }>();

    if (!projectId?.trim()) {
        return <div className="p-6 text-sm text-rose-700">잘못된 프로젝트 ID 입니다.</div>;
    }

    // const [mode, setMode] = useState<WbsListMode>('viewer');

    const { access, isLoading: accessLoading } = useProjectAccessCtx();

    const canEditWbs = useMemo(
        () => !accessLoading && hasPerm(access?.permissions, 'wbs.edit'),
        [access, accessLoading],
    );

    const canEvEntry = useMemo(
        () => !accessLoading && hasPerm(access?.permissions, 'wbs.ev.entry'),
        [access, accessLoading],
    );

    const canEvApprove = useMemo(
        () => !accessLoading && hasPerm(access?.permissions, 'wbs.ev.approve'),
        [access, accessLoading],
    );

    const canWbsAssign = useMemo(
        () =>
            !accessLoading &&
            (access?.roleName === 'PROJECT_OWNER' || access?.roleName === 'PROJECT_MANAGER'),
        [access?.roleName, accessLoading],
    );

    // const isEntryOnly = useMemo(
    //     () => !!access && access.isExternalProjectCompanyUser === true && canEvEntry,
    //     [access, canEvEntry],
    // );
    const isExternalEntryUser =
        !accessLoading &&
        !!access &&
        access.isExternalProjectCompanyUser === true &&
        access.isOwnerCompanyUser !== true &&
        canEvEntry;

    // 외부 입력 사용자는 전용 페이지로 이동
    if (!accessLoading && isExternalEntryUser) {
        return <Navigate to={`/projects/${projectId}/wbs/progress-entry`} replace />;
    }

    // const canEditForMode = useMemo(() => {
    //     if (mode === 'progress') return canEvEntry;
    //     return canEditWbs;
    // }, [canEditWbs, canEvEntry, mode]);

    const canOpenInternalEvEntry =
        !accessLoading &&
        canEvEntry &&
        access?.isExternalProjectCompanyUser !== true &&
        access?.isOwnerCompanyUser === true;

    // const defaultMode: WbsListMode = useMemo(() => {
    //     if (canEvEntry) return 'progress';
    //     return 'viewer';
    // }, [canEvEntry]);

    const asOf = useMemo(() => new Date(), []);
    const { data: currentWbs, isLoading: currentWbsLoading } = useWbsCurrent(projectId, {
        viewAs: 'WEEK',
        at: asOf,
    });

    const hasCurrentWbs = (currentWbs?.items?.length ?? 0) > 0;

    // useEffect(() => {
    //     if (accessLoading) return;
    //     setMode(defaultMode);
    // }, [defaultMode, accessLoading]);

    return (
        <div>
            <div className="w-full mb-4 flex justify-between items-start">
                <div>
                    <h1 className="text-lg font-semibold">Work Breakdown Structure</h1>
                </div>

                {canOpenInternalEvEntry && (
                    <Link to={`/projects/${projectId}/wbs/internal-progress-entry`}>
                        <button
                            type="button"
                            className="rounded border px-3 py-1 text-xs hover:bg-gray-50"
                            title="내부 WBS EV 입력창으로 이동"
                        >
                            EV 입력
                        </button>
                    </Link>
                )}
            </div>

            {!currentWbsLoading && !hasCurrentWbs && (
                <div className="mt-2 mb-2 rounded-xl border border-amber-200 bg-amber-50 px-3 py-2 text-sm text-amber-800">
                    {canEditWbs
                        ? 'WBS가 없습니다. WBS 편집 버튼을 눌러 WBS를 입력하세요.'
                        : '현재 게시된 WBS가 없습니다.'}
                </div>
            )}

            <WbsListContainer
                projectId={projectId}
                canEdit={canEvEntry}
                canApprove={canEvApprove}
                canAssign={canWbsAssign}
                // mode={mode}
                // actorProjectCompanyId={actorProjectCompanyId}
                // compact={false}
            />
        </div>
    );
}

// function Tab({
//     to,
//     label,
//     setMode,
//     isActive,
// }: {
//     to: WbsListMode;
//     label: string;
//     setMode: React.Dispatch<SetStateAction<WbsListMode>>;
//     isActive: boolean;
// }) {
//     return (
//         <button
//             className={`px-3 py-1 text-xs rounded border ${
//                 isActive ? 'bg-gray-700 text-white border-gray-700' : 'bg-white text-gray-700 hover:bg-gray-100'
//             }`}
//             onClick={() => setMode(to)}
//         >
//             {label}
//         </button>
//     );
// }
